<template>
    <v-row>
        <v-col cols="12" class="py-0">
            <v-data-table fixed-header
                          :headers="headers"
                          :height="dataTableHeight"
                          :items="journeys"
                          class="elevation-2"
                          :loading="loadingJourneys"
                          :options.sync="pagination"
                          :footer-props="{
                            'items-per-page-text': 'Workflow per page',
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalJourneys"
                          :must-sort="false">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="font-weight-bold text-capitalize">
                            <v-icon :color="item.mainColor || 'kbBlue'"
                                    class="mr-2">mdi-circle</v-icon>
                            {{ item.name || $t('general.noName') }}
                        </td>
                        <td>
                          <v-icon :color="item.mainColor || 'kbBlue'"
                                    class="mr-2">mdi-circle</v-icon>
                          {{ item.id || $t('general.noJourneyId') }}
                        </td>
                        <td style="text-overflow: ellipsis">{{ dependsOnNames(item.dependsOn) ||  $t('general.noDependencies')}}</td>
                        <td class="text-center">
                            <v-btn class="mr-1"
                                   icon
                                   color="kbDarkBlueText"
                                   @click="viewJourney(item.id)">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <v-menu left>
                              <template v-slot:activator="{ on }">
                                <v-btn color="kbDarkBlueText" text icon v-on="on">
                                  <v-icon>more_vert</v-icon>
                                </v-btn>
                              </template>
                              <v-list color="kbLight">
                                <v-list-item @click="editJourney(item.id)">
                                  <v-list-item-action>
                                    <v-icon color="kbDarkBlueText">mdi-pencil</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title class="kbDarkBlueText--text">{{ $t('general.edit') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="deleteJourney(item.id)">
                                  <v-list-item-action>
                                    <v-icon color="kbRed">delete</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title class="kbDarkBlueText--text">{{ $t('general.delete') }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>

                <template slot="no-data">
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingJourneys">
                            {{$t('general.loadingJourneys')}}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.noJourneysForThisApp')}}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
export default {
  computed: {
    ...mapState({
      journeys: state => state.journey.journeys,
      totalJourneys: state => state.journey.totalJourneys
    }),
    headers () {
      return [
        { text: this.$t('general.name'), value: 'name', sortable: true },
        { text: this.$t('general.journeyId'), value: 'ID', sortable: true },
        { text: this.$t('general.dependsOn'), value: 'dependsOn' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      loadingJourneys: false,
      pagination: {}
    }
  },
  methods: {
    editJourney (nodeId) {
      this.$emit('editJourney', nodeId)
    },
    deleteJourney (journeyId) {
      this.$emit('deleteJourney', journeyId)
    },
    async getJourneys () {
      this.$store.commit('SET_JOURNEYS_PAGINATION', this.pagination)
      this.loadingJourneys = true
      try {
        await this.$store.dispatch('getJourneys', { companyId: this.$route.params.companyid, appId: this.$route.params.appid, search: this.search })
        this.loadingJourneys = false
      } catch (e) {
        this.loadingJourneys = false
        throw e
      }
    },
    dependsOnNames (dependsOnIds) {
      const names = []
      for (const id of dependsOnIds) {
        const name = this.journeys.find(item => item.id === id)
        if (name) {
          names.push(name)
        }
      }
      return names.map(item => item.name).join(', ')
    },
    viewJourney (nodeId) {
      this.$router.push({ name: 'JourneyDetails', params: { journeyId: nodeId } })
    }
  },
  mixins: [ModuleTableHeight],
  props: {
    search: {
      type: [String, Number]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getJourneys()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.pagination.page = 1
      this.getJourneys()
    }
  }
}
</script>
